import { FALLBACK_STORES } from './utils/store';
export const FALLBACK_INITIALIZE_RETURN_VALUE = {
  initialized: false,
  stores: FALLBACK_STORES,
  providers: null
};
export const initializeBraze = async (options, onError) => {
  try {
    const {
      unsafeInitializeBraze
    } = await import('libs/common/braze/unsafe-initialize');
    return await unsafeInitializeBraze(options);
  } catch (error) {
    onError === null || onError === void 0 ? void 0 : onError(error);
    return FALLBACK_INITIALIZE_RETURN_VALUE;
  }
};